const githubapi = {
    state : {
        name : 'githubapi',
        github_api_err_status: false,
        github_api_pending_status: true,
        repos : []

    },
    getters :{
        getGithubApiErrStatus(state){
            return state.github_api_err_status;
        },
        getGithubApiPendingStatus(state){
            return state.github_api_pending_status;
        },
        getRepos(state){
            return state.repos
        },
    },
    actions :{
        initGithubApi({ commit,state }) {
            fetch('https://api.github.com/users/ShineShineDev/repos')
                .then(response => response.json())
                .then(repos => {
                    commit('INIT_GITHUB_API', repos);
                })
                .catch(err => {
                    state.github_api_err_status = true;
                    console.log(err)
                })
                .finally(function(){state.github_api_pending_status = false})
        },
    },
    mutations:{
        INIT_GITHUB_API(state, payload) {
            state.repos = payload
        },
    }
};
export default githubapi